import { ArrowDownOutlined, DeleteFilled, LinkOutlined, StarFilled } from "@ant-design/icons";
import { Button, Checkbox, List, Tag, Tooltip } from "antd/es";
import { memo, useState, useCallback } from "react";
import { downloadModel, deleteModel, getWasabiFileURL, getWasabiFile } from "../../api";
import store from "../../store";
import { deepEquals, getLoraAlpha } from "../../util";
import libyaml from 'yaml'


export const ModelListItem = memo(function ModelListItem({ data, imageCounts, onClick, currentModel, setCurrentModel, selecting, activeLoras, setActiveLoras }) {
    const { size, path, local, fullPath } = data;

    const modelKey = path.replace('/diffusion_pytorch_model.safetensors', '');
    const parts = path.split('/');
    const title = parts.slice(0, 2).join('/');
    const step = data.step;
    const numImages = imageCounts ? (imageCounts[modelKey] || 0) : 0;

    const [favourite, setFavourite] = useState(false);
    const [loading, setLoading] = useState(false);
    const [thumbnails, setThumbnails] = useState([]);

    const isSelected = store.models.use(s => s.selection.includes(modelKey));
    const select = store.models.use(s => s.select);
    const deselect = store.models.use(s => s.deselect);

    const filterImages = store.models.use(s => s.setImageFilter);
    const isLora = fullPath.endsWith('pytorch_lora_weights.safetensors');

    const download = useCallback(() => {
        setLoading(true);
        console.log('Downloading', path);

        downloadModel(path.substr(2) + '/diffusion_pytorch_model.safetensors').then(() => setLoading(false));
    }, [path]);

    const deleteFiles = useCallback(() => {
        setLoading(true);
        console.log('Deleting', path);

        deleteModel(path.substr(2) + '/diffusion_pytorch_model.safetensors').then(() => setLoading(false));
    }, [path]);

    // const downloadLocal = useCallback(() => {
    //     const path2 = path.split("/checkpoint-")[0];
    //     const url = getWasabiFileURL("models/coa-finetune/" + path.substr(2) + '/diffusion_pytorch_model.safetensors');
    //     window.location.href = url;
    // }, [path]);

    const link = getWasabiFileURL(`models/coa-finetune/${fullPath}`);
    const argsUrl = getWasabiFileURL(`models/coa-finetune/${title.substr(2)}/args.yaml`);

    const isCurrent = modelKey === currentModel || activeLoras.some(el => modelKey.startsWith(el.path));

    const changeModel = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isLora) {
            if (isCurrent) {

            } else {
                // Fetch lora parameters so we can set the right values
                const yaml = await getWasabiFile(`models/coa-finetune/${title.substr(2)}/args.yaml`);
                const poepvogeltje = libyaml.parse(yaml, { schema: 'core' }).state;
                const entry = { path: parts.slice(0, 3).join('/'), scales: { unet: { mid: 1, down: 1, up: 1 } }, alpha: getLoraAlpha(poepvogeltje) };

                setActiveLoras([entry]);
                // setActiveLoras([...activeLoras, entry]);
            }
        } else {
            setCurrentModel(modelKey);
        }
    };

    // Download progress:
    // linear-gradient(90deg, #1a3411 50%, #00FFFF00 50%)
    const clickHandler = e => {
        const className = e.target.classList;

        if (className.contains('model-name') || className.contains('model-list-item')) {
            onClick(data);
        }
    };

    const setSelected = (ev) => ev.target.checked ? select(modelKey) : deselect(modelKey);

    return <List.Item className={"model-list-item " + (isCurrent ? "active" : "")} onClick={clickHandler}>
        <div className="favourite-model">
            {selecting
                ? (<>
                    <Checkbox checked={isSelected} onChange={setSelected} />
                </>)
                : <StarFilled onClick={() => setFavourite(v => !v)} className={favourite ? "active" : ""} />}
        </div>

        <span className='model-name' title={JSON.stringify(data)}>{title}</span>
        <Tag color={"default"} style={{ marginRight: 0 }}>{step}</Tag>

        <span>
            <Checkbox checked={isCurrent} onChange={changeModel} style={{ marginLeft: 8 }} />
        </span>

        {numImages ? <Button type="link" size="small" className="model-list-num-images" onClick={() => filterImages(modelKey)}>{numImages} images</Button> : null}

        <span style={{ flexGrow: 1, marginLeft: 8 }}>{/*thumbnails.length */}</span>

        {local ? (
            <Tooltip destroyTooltipOnHide title="Delete model from disk">
                <Button type="default" danger size="small" loading={loading}
                    onClick={e => { e.preventDefault(); e.stopPropagation(); deleteFiles(); }}
                    icon={<DeleteFilled />} />
            </Tooltip>
        ) : (<>
            <Button
                type="default"
                size="small"
                loading={loading}
                onClick={e => { e.preventDefault(); e.stopPropagation(); download(); }}
                icon={<ArrowDownOutlined />} />

            <Button
                href={link}
                type="default"
                size="small"
                icon={<LinkOutlined />} />

        </>)}

        <Tag color={"primary"} style={{ marginRight: 0 }}>
            {(size / 1024 / 1024 / 1024).toFixed(2)} GB
        </Tag>
    </List.Item>;
}, deepEquals);
